import React from "react";

import { Navigate, Route, Routes, useParams } from "react-router-dom";

import AppLayout from "./components/layout/AppLayout";
import { ProtectedRoute } from "./routes/protected-route";
import { LEGACY_REDIRECTS, paths } from "./routes/paths";

import Home from "./routes/home";
import GuidesPage from "./routes/guides";
import ErrorPage from "./routes/error-page";
import ForgotPassword from "./routes/forgot-password";
import SignInUp from "./routes/sign-in-up";
import UserPage from "./routes/user-page";
import UserProductItem from "./routes/user-product-item";

import RegisterLayout from "./routes/register/register-layout";
import ArtomeSerialStep from "./routes/register/artome-serial";
import ProjectorSerialStep from "./routes/register/projector-serial";
import OwnerStep from "./routes/register/owner";
import SummaryStep from "./routes/register/summary";

/** `<Navigate>` cannot template a route param, so the old device URL needs this. */
function LegacyDeviceRedirect() {
  const { product } = useParams();
  return <Navigate to={product ? paths.device(product) : paths.account} replace />;
}

function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path={paths.signInUp} element={<SignInUp />} />
        <Route path={paths.forgotPassword} element={<ForgotPassword />} />

        <Route element={<ProtectedRoute />}>
          <Route index element={<Home />} />
          <Route path={paths.guides} element={<GuidesPage />} />

          <Route path={paths.register} element={<RegisterLayout />}>
            <Route
              index
              element={<Navigate to={paths.registerSerial} replace />}
            />
            <Route path="serial" element={<ArtomeSerialStep />} />
            <Route path="projector" element={<ProjectorSerialStep />} />
            <Route path="owner" element={<OwnerStep />} />
            <Route path="summary" element={<SummaryStep />} />
          </Route>

          <Route path={paths.account} element={<UserPage />} />
          <Route path={paths.accountDevices} element={<UserPage />} />
          <Route path={paths.devicePattern} element={<UserProductItem />} />

          <Route path="/user-product/:product" element={<LegacyDeviceRedirect />} />
          {LEGACY_REDIRECTS.map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}

          <Route path="*" element={<ErrorPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
